import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { addInboundFeed, getInboundFeeds } from "../../../Services/API/InboundFeeds";
import LoadingBar from "../../LoadingBar/LoadingBar";
import { StyledTextField } from "../../TextField/TextField";
import prettifyXml from "prettify-xml/dist";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function InboundFeedModal({ openModal, setData, setShowSignifier, setShowError, clientID }) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [sourceFile, setSourceFile] = useState("");
  const [fileType, setFileType] = useState("");
  const [transform, setTransform] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isCompressed, setIsCompressed] = useState(false);
  const [addProcessing, setAddProcessing] = useState(false);

  const data = {
    ClientID: clientID,
    FeedName: name,
    FeedUrl: url,
    SourceFileFullPath: sourceFile,
    SourceFileType: fileType,
    Transform: transform,
    IsActive: isActive,
    IsCompressed: isCompressed,
  };

  const checkAllEntered = () => {
    if (name === "" || fileType === "") {
      return false;
    }
    return true;
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addInboundFeed(data).then(() => {
        getInboundFeeds(clientID).then((res) => {
          setShowSignifier(true);
          if (res) {
            for (const i in res) {
              res[i].isActiveString = res[i].isActive ? "Yes" : "No";
              res[i].isCompressedString = res[i].isCompressed ? "Yes" : "No";
            }
            setData(res);
            openModal(false);
          } else {
            setShowError(true);
          }
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Feed</p>
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="Name"
                  value={name}
                  error={showInputError && name === ""}
                  className={classes.textField}
                  variant="standard"
                  fullWidth
                  required
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && name === "" && (
                  <FormHelperText className={classes.error}>Name Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="URL"
                  value={url}
                  variant="standard"
                  fullWidth
                  onChange={(e) => setUrl(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="Source File"
                  value={sourceFile}
                  variant="standard"
                  fullWidth
                  onChange={(e) => setSourceFile(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="File Type"
                  value={fileType}
                  error={showInputError && fileType === ""}
                  className={classes.textField}
                  variant="standard"
                  fullWidth
                  required
                  onChange={(e) => setFileType(e.target.value)}
                />
                {showInputError && fileType === "" && (
                  <FormHelperText className={classes.error}>File Type Required</FormHelperText>
                )}
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox color="primary" checked={isActive} onChange={() => setIsActive(!isActive)} />
                  }
                  label="Active"
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={isCompressed}
                      onChange={() => setIsCompressed(!isCompressed)}
                    />
                  }
                  label="Compressed"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="Transform"
                  value={transform !== "" ? prettifyXml(transform, { newline: "\n" }) : transform}
                  variant="standard"
                  fullWidth
                  multiline
                  rows={1}
                  rowsMax={20}
                  onChange={(e) => setTransform(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "#82B288", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
